<div class="form-group mt-0">
  <label>{{ field?.label }}</label>
  <div class="row">
    <div class="col-12 col-md-4" *ngIf="field?.featureLabels?.field1 as field1">
      <app-input [field]="field1" [form]="inputForm"></app-input>
    </div>
    <div class="col-12 col-md-4" *ngIf="field?.featureLabels?.field2 as field2">
      <app-select [field]="field2" [form]="selectForm"></app-select>
    </div>
    <div class="col-12 col-md-4">
      <app-select [field]="taxTypeField" [form]="taxTypeForm"></app-select>
    </div>  
    <div class="col-12" *ngIf="field?.showMultipleAddbtn">
      <div class="row">
        <div class="col-12 add-anotherOption">
          <a
            (click)="addFeature()"
            [class.disabled]="!featureText1 || !featureText2 || !featureText3"
            [attr.aria-disabled]="!featureText1 || !featureText2 || !featureText3"
            [style.pointerEvents]="!featureText1 || !featureText2 || !featureText3 ? 'none' : 'auto'"
          >
            <em class="icon-newpost-plus me-2"></em>
            {{ field?.featureLabels?.button?.label || 'Add Another Option' }}
          </a>
        </div>
      </div>
    </div>    
  </div>

  <div *ngFor="let feature of features; let idx = index" class="form-access-content">
    <ul>
      <li>
        <span>{{ feature?.text1 }} - {{ feature?.text2 }} - {{ feature?.text4 }}</span>
        <a 
          role="button" 
          class="text-danger" 
          (click)="removeFeature(idx)" 
          [class.disabled]="isDisabled" 
          [style.pointerEvents]="isDisabled ? 'none' : 'auto'"
        >
          &times;
        </a>
      </li>
    </ul>
  </div>
</div>